import { Component, EventEmitter, Input, OnInit, OnDestroy, Output, NgZone } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ApiService } from "src/app/services/api.service";
import { LanguageService } from "src/app/services/language.service";
import { RoutingService } from "src/app/services/routing.service";
import { Observable, Subject, Subscription, takeUntil } from "rxjs";
import { Entity } from "src/app/models/mvp-query-response-dto";
import { EntityType } from "src/app/enums/entity-type.enum";
import { ManuscriptDto } from "src/app/models/manuscript-details-dto";

@Component({
  selector: 'manuscript',
  templateUrl: './manuscript.component.html',
  styleUrls: ['./manuscript.component.scss'],
})
export class ManuscriptComponent implements OnInit {    
    private entityDetailsSubscription?: Subscription;
    private languageSubscription?: Subscription;
    closeClicked: Subject<void> = new Subject<void>();
    @Output() onShapeLeftClick = new EventEmitter<any[]>();
    @Output() onClose = new EventEmitter<void>();
    selectedManuscriptDetails!: ManuscriptDto;
    manuscriptDetailsIsLoading: boolean = true;
    entityId: number = -1;
    entity: Entity = {} as Entity;
    entityType: string = EntityType.MANUSCRIPT;
    currentLanguage$!: Observable<string>;
    currentLang: string = 'he';

  constructor(
     private routingService: RoutingService,
     private apiService: ApiService,
     private translate: TranslateService,
     private languageService: LanguageService,
     private ngZone: NgZone) {
  }

  ngOnInit(): void {
    this.currentLanguage$ = this.languageService.currentLanguage$;

    // Subscribe to language changes
    this.languageSubscription = this.currentLanguage$.subscribe(lang => {
      this.currentLang = lang;
    });

    this.entityDetailsSubscription = this.routingService.entityDetails$
      .subscribe(entityDetails => {
        this.ngZone.run(() => {
          const { id, type } = entityDetails;
          if (!!id && [EntityType.MANUSCRIPT].includes(type as EntityType)) {
            this.entityId = id;
            this.entityType = type;
            this.getManuscriptDetails(id, type);
          }
        });
      });
  }

  getManuscriptDetails(entityId: number, entityType: string) {
    this.manuscriptDetailsIsLoading = true;
    this.apiService.getManuscriptDetails(entityId)
      .pipe(takeUntil(this.closeClicked))
      .subscribe({
        next: (res: ManuscriptDto) => {
          this.selectedManuscriptDetails = res;
          this.stopLoading();
        },
        error: () => this.stopLoading(),
        complete: () => {
          this.stopLoading(); 
        }
      });
  }

  stopLoading() {
    this.manuscriptDetailsIsLoading = false;
  }
  
  ngOnDestroy(): void {
    this.entityDetailsSubscription?.unsubscribe();
    this.languageSubscription?.unsubscribe();
  }

  getDetailsTitle(): string {
    const prefix = this.translate.instant('iaa.app.manuscript.deadSeaScrolls');
    
    const title = this.currentLang === 'he' 
      ? (this.selectedManuscriptDetails?.manuscriptTitle?.hebrew || this.selectedManuscriptDetails?.manuscriptTitle?.english || '')
      : (this.selectedManuscriptDetails?.manuscriptTitle?.english || this.selectedManuscriptDetails?.manuscriptTitle?.hebrew || '');
    return title ? `${prefix} - ${title}` : prefix;
  }
}